<template>
  <div class="fold props-group">
    <el-form-item label="默认折叠">
      <el-switch v-model="component.properties.defaultFold" @change="$emit('update', 'defaultFold')"></el-switch>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-fold',
  props: ['component']
}
</script>
<style lang="scss">
  .fold.props-group{
    .el-form-item{
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/fold.vue